/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface SellersRS {

        "sellers"?: Array<SellerModel>;
    }

}
